import React, { createContext, useState } from 'react';

type FiltersContextValue = {
  formKey: number;
  collapsed: boolean;
  filtersCount: number;
  resetForm: () => void;
  toggleCollapsed: () => void;
  setFiltersCount: (n: number) => void;
};

export const FiltersContext = createContext<FiltersContextValue>({
  formKey: 1,
  collapsed: true,
  filtersCount: 0,
  resetForm: () => {},
  toggleCollapsed: () => {},
  setFiltersCount: () => {},
});

export const FiltersContextProvider: React.FC = ({ children }) => {
  const [formKey, setFormKey] = useState(1);
  const [collapsed, setCollapsed] = useState(true);
  const [filtersCount, setFiltersCount] = useState(0);

  const value: FiltersContextValue = {
    formKey,
    collapsed,
    filtersCount,
    resetForm: () => setFormKey((prev) => prev + 1),
    toggleCollapsed: () => setCollapsed((prev) => !prev),
    setFiltersCount,
  };

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};
